import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    dialogContent: {
        minWidth: '400px',
        padding: '8px 0 '
    },
    content: {
        padding: '0 24px 8px',
        borderBottom: '2px solid #f0f0f0'
    },
    btnsContainer: {
        width: '70%',
        margin: '8px auto 0',
        display: 'flex',
        justifyContent: 'center'
    },
    acceptBtn: {
        marginLeft: 12,
        width: '120px'
    },
    cancelBtn: {
        width: '120px',
        border: `2px solid ${Colors.DARK_BLUE}`,
        background: '#fff',
        color: Colors.DARK_BLUE,
        '&:hover': {
            background: 'white',
            color: Colors.DARK_BLUE
        }
    }
}))

export { useStyles }